import gql from 'graphql-tag'

export default gql`
  mutation courses_update_mutation(
    $id: ID!
    $description: String!
    $difficultyLevel: CourseDifficultyLevel!
    $image: Upload
    $instructors: [ID!]!
    $length: CourseLength!
    $mailchimpTag: String!
    $order: Int!
    $requirements: String!
    $shortDescription: String!
    $slackChannelId: String!
    $slackChannelName: String!
    $syllabusUrl: String!
    $slug: String!
    $subjects: [CourseSubject!]!
    $title: String!
    $chapterIds: [ID!]
    $isBeta: Boolean!
    $overview: [String!]!
    $targetAudience: String!
    $resourceUrl: String
    $hasAllChapters: Boolean!
    $status: CourseStatus!
  ) {
    courseUpdate(
      id: $id
      description: $description
      difficultyLevel: $difficultyLevel
      image: $image
      instructors: $instructors
      length: $length
      mailchimpTag: $mailchimpTag
      order: $order
      requirements: $requirements
      shortDescription: $shortDescription
      slackChannelId: $slackChannelId
      slackChannelName: $slackChannelName
      syllabusUrl: $syllabusUrl
      slug: $slug
      subjects: $subjects
      title: $title
      chapterIds: $chapterIds
      isBeta: $isBeta
      overview: $overview
      targetAudience: $targetAudience
      resourceUrl: $resourceUrl
      hasAllChapters: $hasAllChapters
      status: $status
    ) {
      id
    }
  }
`
